import { render, staticRenderFns } from "./ReporteCargaPetroleo.vue?vue&type=template&id=042b4b48&"
import script from "./ReporteCargaPetroleo.vue?vue&type=script&lang=js&"
export * from "./ReporteCargaPetroleo.vue?vue&type=script&lang=js&"
import style0 from "./ReporteCargaPetroleo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports